import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";
import Axios from "./../../apiConfig/Axios";
import apiRoutes from "services/apiRoutes";

//////////////////////////////////////MobileRequest//////////////////////////
const fetchMobileRequestFn = async () => {
  const res = await Axios.post<GlobalApiResponseType<responseMobileRequest>>(
    apiRoutes.twoFactor.MobileRequest
  );
  return res.data;
};

export const useMobileRequest = (
  option?:
    | Omit<
        UseQueryOptions<GlobalApiResponseType<responseMobileRequest>, Error>,
        "mutationKey" | "mutationFn"
      >
    | undefined
) => {
  return useQuery<GlobalApiResponseType<responseMobileRequest>, Error>(
    ["mobile-request"],
    fetchMobileRequestFn,
    option
  );
};

///////////////////////////////TurnOnMobileState or TurnOffMobileState////////////////////////////////
const fetchTurntoggleMobileStateFn = async (data: reqTurnToggleMobileType) => {
  const { state, ...rest } = data;
  const res = await Axios.post<
    GlobalApiResponseType<string>
  >(
    state
      ? apiRoutes.twoFactor.TurnOffMobileState
      : apiRoutes.twoFactor.TurnOnMobileState,
    rest
  );
  return res.data;
};

export const useTurntoggleMobileState = (
  option?: Omit<
    UseMutationOptions<
      GlobalApiResponseType<string>,
      Error,
      reqTurnToggleMobileType
    >,
    "mutationKey" | "mutationFn"
  >
) => {
  return useMutation<
    GlobalApiResponseType<string>,
    Error,
    reqTurnToggleMobileType
  >(fetchTurntoggleMobileStateFn, option);
};
